var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-table-wrapper"},_vm._l((_vm.rows),function(row){return _c('div',{key:row,staticClass:"skeleton-table-row"},[_vm._t("default",function(){return _vm._l((_vm.columns),function(cell){return _c('KSkeletonBox',{key:cell,class:{
          'mr-6': cell !== _vm.columns,
          'ml-auto': cell === _vm.columns,
          'skeleton-cell': true
        },attrs:{"width":_vm.calcWidth(cell, _vm.columns)}})})})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }